import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Checkbox from '@8x8/oxygen-checkbox'
import styled from 'styled-components'

import { getRecordingSettings } from '~/selectors/room-settings'
import { updateRecordingSettings } from '~/actions/room-settings'
import { translate } from '~/core/translate'
import { SettingsContainer, SettingsTitle } from './components'

const AdvancedOptions = styled.div`
  display: flex;
  flex-direction: column;
  margin: 12px 0 0 36px;
  font-size: 14px;
`

const AdvancedOptionsTitle = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 8px;
  cursor: pointer;
`

const RecordingSettings = () => {
  const dispatch = useDispatch()
  const {
    autoAudioRecording,
    autoVideoRecording,
    autoTranscriptions
  } = useSelector(getRecordingSettings)

  const handleUpdate = useCallback(payload => {
    dispatch(updateRecordingSettings(payload))
  }, [])

  return (
    <SettingsContainer>
      <SettingsTitle>{translate('recordings')}</SettingsTitle>
      <Checkbox
        label={translate('start_recording_automatically')}
        isChecked={autoAudioRecording || autoAudioRecording || autoTranscriptions}
        onChange={() => {
          const autoRecording = !(autoAudioRecording || autoVideoRecording || autoTranscriptions)
          handleUpdate({
            autoVideoRecording: autoRecording,
            autoAudioRecording: autoRecording,
            autoTranscriptions: autoRecording
          })
        }}
      />
      {(autoAudioRecording || autoVideoRecording || autoTranscriptions) && (
        <AdvancedOptions>
          <AdvancedOptionsTitle>
            {translate('recordings_when_enabled')}
          </AdvancedOptionsTitle>
          <Checkbox
            label={translate('start_audio_video_recording_automatically')}
            isChecked={autoVideoRecording}
            onChange={() => handleUpdate({
              autoVideoRecording: !autoVideoRecording,
              autoAudioRecording: !autoAudioRecording
            })}
          />
          <Checkbox
            label={translate('start_transcribing_automatically')}
            isChecked={autoTranscriptions}
            onChange={() => handleUpdate({
              autoTranscriptions: !autoTranscriptions
            })}
          />
        </AdvancedOptions>
      )}
    </SettingsContainer>
  )
}

export default RecordingSettings
